import { Avatar, Box, Button, Flex, Heading, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import i18n from "../locales/i18n";
import { MenuList } from "../utils/menuItem";
import { FaLanguage } from "react-icons/fa";
import { BiLogOutCircle } from "react-icons/bi";
import { HiMenu } from "react-icons/hi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMyProfile } from "../http/users";
import _intersection from "lodash/intersection";

interface MenuComponentProps {
    isCollapsed?: boolean;
    onToggleCollapse?: () => void;
}

export default function MenuComponent({ isCollapsed = false, onToggleCollapse }: MenuComponentProps) {
    const { t } = useTranslation('common');
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [lang, setLang] = useState<string>('en');
    const [user, setUser] = useState<any>(undefined);
    i18n.on('languageChanged', (locale) => {
        setLang(locale);
    });

    const onGetGreeting = () => {
        const user = localStorage.getItem('user');
        if (user) {
            const currentHour = new Date().getHours();
            let greeting: string;

            if (currentHour >= 5 && currentHour < 12) {
                greeting = 'Good morning';
            } else if (currentHour >= 12 && currentHour < 18) {
                greeting = 'Good afternoon';
            } else {
                greeting = 'Good evening';
            }
            // @ts-ignore
            return greeting;
        }
    }
    useEffect(() => {
        onGetMyProfile();
    }, []);

    const onGetMyProfile = async () => {
        try {
            const response = await getMyProfile();
            setUser(response.data);
        } catch (e) {
            console.log(e)
        }
    }



    const renderToggleButton = () => (
        <Tooltip label={isCollapsed ? t('expand') : t('collapse')} placement="right">
            <IconButton
                aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                icon={<HiMenu size={20} />}
                onClick={onToggleCollapse}
                variant="ghost"
                color="#ffffff"
                _hover={{ background: 'rgba(255,255,255,0.2)' }}
                size="sm"
            />
        </Tooltip>
    );

    if (isCollapsed) {
        return (
            <Box mt={"20px"} p={"8px"} display="flex" flexDir="column" alignItems="center" h="calc(100vh - 40px)">
                {onToggleCollapse && (
                    <Flex w="100%" justify="flex-end" mb="12px">
                        {renderToggleButton()}
                    </Flex>
                )}
                <Text fontSize="16px" fontWeight={800} color={"#ffffff"} mb="16px" noOfLines={1}>
                    IEP
                </Text>
                {user && (
                    <Tooltip label={user.displayName} placement="right">
                        <Box mb="16px" cursor="pointer" onClick={() => navigate("/user/" + user.id, { state: user })}>
                            <Avatar name={user.displayName} src={user.image} size="md" />
                        </Box>
                    </Tooltip>
                )}
                <Box display="flex" flexDir="column" alignItems="center" gap="4px" flex="1">
                    {MenuList.map((menu) =>
                        user && (_intersection(user?.roles, menu.accessTo).length > 0) && (
                            <Tooltip key={menu.path} label={t(`${menu.label}`)} placement="right">
                                <IconButton
                                    aria-label={t(`${menu.label}`)}
                                    icon={<menu.icon size={20} />}
                                    onClick={() => navigate(menu.path)}
                                    background={pathname === menu.path ? "#ffffff" : "transparent"}
                                    color={pathname !== menu.path ? "#ffffff" : "#1b73e8"}
                                    _hover={{ background: pathname === menu.path ? "#ffffff" : "rgba(255,255,255,0.2)" }}
                                    variant="ghost"
                                    size="md"
                                    mb="4px"
                                />
                            </Tooltip>
                        )
                    )}
                    <Tooltip label={lang === 'ne' ? 'Change Language' : 'भाषा परिवर्तन'} placement="right">
                        <IconButton
                            aria-label="Change language"
                            icon={<FaLanguage size={20} />}
                            onClick={() => i18n.changeLanguage(i18n.language === 'ne' ? 'en' : 'ne').then(() => { }).catch(() => { })}
                            color="#ffffff"
                            _hover={{ background: "rgba(255,255,255,0.2)" }}
                            variant="ghost"
                            size="md"
                            mb="4px"
                        />
                    </Tooltip>
                    <Tooltip label={t('logout')} placement="right">
                        <IconButton
                            aria-label={t('logout')}
                            icon={<BiLogOutCircle size={20} />}
                            onClick={() => { localStorage.clear(); window.location.reload(); }}
                            color="#ffffff"
                            _hover={{ background: "rgba(255,255,255,0.2)" }}
                            variant="ghost"
                            size="md"
                            mb="4px"
                        />
                    </Tooltip>
                </Box>
            </Box>
        );
    }

    return (
        <Box mt={"20px"} p={"12px"} display="flex" flexDir="column" h="calc(100vh - 40px)">
            {onToggleCollapse && (
                <Flex w="100%" justify="flex-end" mb="8px">
                    {renderToggleButton()}
                </Flex>
            )}
            <Text fontSize="24px" fontWeight={900} textAlign={"center"} color={"#ffffff"} mb="20px">
                {t('mainName')}
            </Text>
            <Box flex="1" overflowY="auto">
                {user && (
                    <Flex flex='1' gap='4' alignItems='center'
                        cursor={'pointer'}
                        background='#ffffff' mb={'20px'} p={'10px'} borderRadius={'8px'} onClick={() => navigate("/user/" + user.id, { state: user })}>
                        <Box w={'20%'}>
                            <Avatar name={user.displayName} src={user.image} w={'100%'} />
                        </Box>
                        <Box w={'80%'}>
                            <Heading size='sm'>{onGetGreeting()}, {user.displayName}</Heading>
                            <Text>{user.address}</Text>
                        </Box>
                    </Flex>
                )}
                {MenuList.map((menu) =>
                    user && (_intersection(user?.roles, menu.accessTo).length > 0) && (
                        <Button
                            key={menu.path}
                            leftIcon={<menu.icon />}
                            background={pathname === menu.path ? "#ffffff" : "#1b73e8"}
                            onClick={() => navigate(menu.path)}
                            color={pathname !== menu.path ? "#ffffff" : "#1b73e8"}
                            _hover={pathname === menu.path ? {} : { background: "#ffffff", color: "#1b73e8" }}
                            variant='solid'
                            w={"100%"}
                            borderRadius={"20px"}
                            mb={"18px"}
                        >
                            {t(`${menu.label}`)}
                        </Button>
                    )
                )}
                <Button
                    leftIcon={<FaLanguage />}
                    background="#1b73e8"
                    onClick={() => i18n.changeLanguage(i18n.language === 'ne' ? 'en' : 'ne').then(() => { }).catch(() => { })}
                    color="#ffffff"
                    _hover={{ background: "#ffffff", color: "#1b73e8" }}
                    variant='solid'
                    w={"100%"}
                    borderRadius={"20px"}
                    mb={"18px"}
                >
                    {lang === 'ne' ? 'Change Language' : 'भाषा परिवर्तन'}
                </Button>
                <Button
                    leftIcon={<BiLogOutCircle />}
                    background="#1b73e8"
                    onClick={() => { localStorage.clear(); window.location.reload(); }}
                    color="#ffffff"
                    _hover={{ background: "#ffffff", color: "#1b73e8" }}
                    variant='solid'
                    w={"100%"}
                    borderRadius={"20px"}
                    mb={"18px"}
                >
                    {t('logout')}
                </Button>
            </Box>
        </Box>
    );
}
